import { render, staticRenderFns } from "./learner-identity.vue?vue&type=template&id=0d2d7824&scoped=true"
import script from "./learner-identity.ts?vue&type=script&lang=ts&external"
export * from "./learner-identity.ts?vue&type=script&lang=ts&external"
import style0 from "./learner-identity.scss?vue&type=style&index=0&id=0d2d7824&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2d7824",
  null
  
)

export default component.exports